var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first"},[_c('News'),_c('div',{staticClass:"right"},[_c('Maps'),_c('Gonggao')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }